// removed by extract-text-webpack-plugin
module.exports = {"paymentMethod":"eqc_Q","radioContainer":"_3TT1x","paymentMethodInput":"_3k8yt","icon":"_2I7rV"};


//////////////////
// WEBPACK FOOTER
// ./components/PaymentMethodItem/PaymentMethodItem.scss
// module id = 275
// module chunks = 0 1